import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const Shocking = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <g clipPath="url(#clip0_4706_230266)">
        <path
          d="M9.95605 17.043C13.8393 17.043 16.9873 13.895 16.9873 10.0117C16.9873 6.12847 13.8393 2.98047 9.95605 2.98047C6.0728 2.98047 2.9248 6.12847 2.9248 10.0117C2.9248 13.895 6.0728 17.043 9.95605 17.043Z"
          fill="url(#paint0_radial_4706_230266)"
        />
        <path
          d="M9.95605 17.043C13.8393 17.043 16.9873 13.895 16.9873 10.0117C16.9873 6.12847 13.8393 2.98047 9.95605 2.98047C6.0728 2.98047 2.9248 6.12847 2.9248 10.0117C2.9248 13.895 6.0728 17.043 9.95605 17.043Z"
          fill="url(#paint1_radial_4706_230266)"
        />
        <path
          d="M9.95996 17.0234C13.8432 17.0234 16.9912 13.8754 16.9912 9.99219C16.9912 6.10894 13.8432 2.96094 9.95996 2.96094C6.07671 2.96094 2.92871 6.10894 2.92871 9.99219C2.92871 13.8754 6.07671 17.0234 9.95996 17.0234Z"
          fill="url(#paint2_radial_4706_230266)"
          fillOpacity="0.8"
        />
        <path
          d="M9.95899 2.96094C6.07573 2.96094 2.92774 6.10893 2.92773 9.99218C2.92773 13.8754 6.07573 17.0234 9.95898 17.0234C13.8422 17.0234 16.9902 13.8754 16.9902 9.99219C16.9902 6.10893 13.8422 2.96094 9.95899 2.96094Z"
          fill="url(#paint3_radial_4706_230266)"
          fillOpacity="0.8"
        />
        <path
          d="M9.95801 17.0244C13.8413 17.0244 16.9893 13.8764 16.9893 9.99316C16.9893 6.10991 13.8413 2.96191 9.95801 2.96191C6.07476 2.96191 2.92676 6.10991 2.92676 9.99316C2.92676 13.8764 6.07476 17.0244 9.95801 17.0244Z"
          fill="url(#paint4_linear_4706_230266)"
        />
        <path
          d="M5.3441 12.7261C6.08015 13.9222 6.17653 16.3023 6.13271 17.3428C6.13271 17.5619 5.78441 18 4.39118 18C2.64964 18 2.36184 17.2352 2.27176 17.0307C2.17603 16.8133 2.4032 15.6177 2.48535 15.0427C2.56749 14.4676 2.48535 13.2519 2.18961 12.7261C1.89388 12.2004 1.91031 11.3132 2.48535 11.0667C3.06038 10.8203 4.42404 11.231 5.3441 12.7261Z"
          fill="url(#paint5_radial_4706_230266)"
        />
        <path
          d="M5.3441 12.7261C6.08015 13.9222 6.17653 16.3023 6.13271 17.3428C6.13271 17.5619 5.78441 18 4.39118 18C2.64964 18 2.36184 17.2352 2.27176 17.0307C2.17603 16.8133 2.4032 15.6177 2.48535 15.0427C2.56749 14.4676 2.48535 13.2519 2.18961 12.7261C1.89388 12.2004 1.91031 11.3132 2.48535 11.0667C3.06038 10.8203 4.42404 11.231 5.3441 12.7261Z"
          fill="url(#paint6_radial_4706_230266)"
          fillOpacity="0.6"
        />
        <path
          d="M8.72778 11.0423C9.09537 10.2356 9.7222 10.0957 10.0785 10.0957C10.4347 10.0957 11.022 10.2112 11.4284 11.0423C11.8994 12.0052 12.6873 14.322 12.1234 15.1886C11.5596 16.0552 10.6815 16.2152 10.0778 16.2152C9.47405 16.2152 8.59665 16.0552 8.03278 15.1886C7.46891 14.322 8.29842 11.9846 8.72778 11.0423Z"
          fill="#3F1C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0788 10.1178C9.72881 10.1178 9.11173 10.2547 8.74882 11.0511C8.53462 11.5212 8.22046 12.3397 8.03031 13.1484C7.93523 13.5527 7.87135 13.9538 7.8662 14.3073C7.86104 14.6613 7.91488 14.9645 8.05219 15.1755C8.60998 16.0327 9.47784 16.1917 10.0781 16.1917C10.6783 16.1917 11.5469 16.0327 12.1047 15.1755C12.2421 14.9644 12.2984 14.6624 12.2965 14.31C12.2946 13.9582 12.2346 13.559 12.1421 13.156C11.9572 12.3499 11.6431 11.5316 11.4083 11.0516C11.2069 10.6398 10.9616 10.4069 10.724 10.2767C10.4862 10.1463 10.2544 10.1178 10.0788 10.1178ZM8.70737 11.0322C9.07963 10.2152 9.71623 10.0722 10.0788 10.0723C10.2594 10.0723 10.4993 10.1016 10.7459 10.2367C10.9926 10.372 11.2442 10.6124 11.4492 11.0316C11.6854 11.5145 12.0007 12.3361 12.1865 13.1458C12.2794 13.5507 12.3401 13.9534 12.3421 14.3098C12.344 14.6656 12.2874 14.9782 12.1429 15.2003C11.5729 16.0763 10.6853 16.2373 10.0781 16.2373C9.47089 16.2373 8.58396 16.0763 8.014 15.2003C7.86938 14.9781 7.81545 14.6641 7.82065 14.3066C7.82587 13.9487 7.89048 13.544 7.98596 13.1379C8.17694 12.3257 8.49222 11.5044 8.70737 11.0322Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0787 9.87793C10.288 9.87793 10.5769 9.91195 10.8756 10.0757C11.1773 10.2411 11.4646 10.5255 11.6897 10.9857C11.9311 11.4794 12.2491 12.3086 12.4372 13.1284C12.5313 13.5385 12.5956 13.9574 12.5976 14.3371C12.5997 14.7094 12.5425 15.0852 12.3543 15.3744C11.7155 16.3562 10.7198 16.5274 10.078 16.5274C9.4361 16.5274 8.44112 16.3561 7.80235 15.3744C7.61306 15.0835 7.55938 14.7046 7.56482 14.3314C7.57037 13.9503 7.63862 13.5297 7.73516 13.1191C7.92835 12.2975 8.24565 11.4712 8.46332 10.9935C8.88964 10.0579 9.64116 9.87791 10.0787 9.87793M10.0787 10.1931C9.72827 10.1931 9.11172 10.3308 8.75016 11.1242C8.32784 12.051 7.51193 14.3501 8.06656 15.2025C8.62118 16.0549 9.48419 16.2122 10.078 16.2122C10.6718 16.2122 11.5355 16.0549 12.0901 15.2025C12.6448 14.3501 11.8697 12.0713 11.4065 11.1242C11.0067 10.3068 10.4291 10.1931 10.0787 10.1931Z"
          fill="url(#paint7_linear_4706_230266)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1889 15.0483C12.1677 15.1001 12.1427 15.1485 12.1137 15.1931C11.5526 16.0554 10.6789 16.2146 10.0782 16.2146C9.47746 16.2146 8.60444 16.0554 8.04338 15.1931C7.99617 15.1206 7.95968 15.0381 7.93262 14.9472C8.43464 14.5057 9.17576 14.2266 10.0073 14.2266C10.8965 14.2266 11.6871 14.5486 12.1889 15.0483Z"
          fill="url(#paint8_radial_4706_230266)"
        />
        <path
          d="M15.2992 6.63445C15.8994 8.16101 15.4609 9.76224 14.3198 10.2109C13.1786 10.6596 11.767 9.78575 11.1668 8.25919C10.5666 6.73264 11.0052 5.13141 12.1463 4.68275C13.2874 4.23409 14.6991 5.1079 15.2992 6.63445Z"
          fill="url(#paint9_radial_4706_230266)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.726 9.33957C15.5317 10.0491 15.0886 10.6427 14.4197 10.9057C13.7507 11.1688 13.022 11.0358 12.3965 10.6486C11.771 10.2615 11.2319 9.61248 10.9123 8.79969C10.5928 7.98689 10.5455 7.14449 10.7398 6.43505C10.9341 5.72555 11.3772 5.13188 12.0462 4.86887C12.7151 4.60587 13.4439 4.73881 14.0694 5.12599C14.6948 5.51314 15.2339 6.16214 15.5535 6.97493C15.8731 7.78773 15.9203 8.63013 15.726 9.33957ZM14.3197 10.6514C15.4608 10.2027 15.8993 8.6015 15.2991 7.07494C14.6989 5.54839 13.2873 4.67458 12.1462 5.12324C11.005 5.5719 10.5665 7.17312 11.1667 8.69968C11.7669 10.2262 13.1785 11.1 14.3197 10.6514Z"
          fill="url(#paint10_linear_4706_230266)"
        />
        <path
          d="M4.76813 6.63445C4.16794 8.16101 4.60646 9.76224 5.7476 10.2109C6.88874 10.6596 8.30037 9.78575 8.90056 8.25919C9.50075 6.73264 9.06223 5.13141 7.92109 4.68275C6.77996 4.23409 5.36833 5.1079 4.76813 6.63445Z"
          fill="url(#paint11_radial_4706_230266)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3404 8.38351C4.53471 9.09301 4.97779 9.68669 5.64674 9.94969C6.31568 10.2127 7.04445 10.0798 7.66993 9.69258C8.29537 9.30543 8.8345 8.65643 9.15407 7.84363C9.47363 7.03084 9.52087 6.18844 9.32658 5.479C9.13227 4.7695 8.68919 4.17583 8.02025 3.91282C7.3513 3.64981 6.62254 3.78275 5.99705 4.16993C5.37162 4.55708 4.83248 5.20608 4.51292 6.01888C4.19335 6.83168 4.14611 7.67408 4.3404 8.38351ZM5.74675 9.69533C4.60561 9.24667 4.16709 7.64544 4.76728 6.11889C5.36747 4.59233 6.7791 3.71852 7.92024 4.16718C9.06138 4.61584 9.4999 6.21707 8.8997 7.74362C8.29951 9.27018 6.88788 10.144 5.74675 9.69533Z"
          fill="url(#paint12_linear_4706_230266)"
        />
        <path
          d="M8.3693 8.01805C8.11876 8.95304 7.35282 9.5602 6.6585 9.37415C5.96419 9.18811 5.60443 8.27933 5.85497 7.34433C6.1055 6.40933 6.87145 5.80218 7.56576 5.98822C8.26007 6.17426 8.61983 7.08305 8.3693 8.01805Z"
          fill="#421D30"
        />
        <path
          d="M11.6737 8.01805C11.9242 8.95304 12.6902 9.5602 13.3845 9.37415C14.0788 9.18811 14.4385 8.27933 14.188 7.34433C13.9375 6.40933 13.1715 5.80218 12.4772 5.98822C11.7829 6.17426 11.4231 7.08305 11.6737 8.01805Z"
          fill="#421D30"
        />
        <path
          d="M14.9114 12.9727C14.0702 14.3396 13.9601 17.0597 14.0102 18.2489C14.0102 18.4993 14.4082 19 16.0005 19C17.9908 19 18.3197 18.1259 18.4227 17.8922C18.5321 17.6438 18.2725 16.2774 18.1786 15.6202C18.0847 14.963 18.1786 13.5735 18.5166 12.9727C18.8545 12.3718 18.8358 11.3579 18.1786 11.0763C17.5214 10.7946 15.9629 11.264 14.9114 12.9727Z"
          fill="url(#paint13_radial_4706_230266)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.74984 3.82171) scale(13.1441)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.43" stopColor="#FFD400" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.77211 4.08627) rotate(54.7041) scale(13.945 13.929)"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.95996 10.3124) rotate(-90) scale(7.73511 7.38974)"
        >
          <stop offset="0.848958" stopColor="#FFC60C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7039" stopOpacity="0.68" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.95899 9.67202) rotate(90) scale(7.35142 7.28983)"
        >
          <stop offset="0.847356" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4706_230266"
          x1="9.95801"
          y1="15.2491"
          x2="9.95801"
          y2="2.96191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD201" stopOpacity="0" />
          <stop offset="0.391745" stopColor="#FF35C6" stopOpacity="0.2" />
          <stop offset="1" stopColor="#0066FF" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.93239 14.5) rotate(-11.9967) scale(3.28087 5.20184)"
        >
          <stop stopColor="#FFE150" />
          <stop offset="0.526042" stopColor="#FFC321" />
          <stop offset="1" stopColor="#E35011" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.4803 14.1665) rotate(154.564) scale(2.05993 2.69986)"
        >
          <stop offset="0.185214" stopColor="#FF8E00" stopOpacity="0.9" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_4706_230266"
          x1="10.0811"
          y1="10.4785"
          x2="10.0811"
          y2="15.9269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E78F00" />
          <stop offset="1" stopColor="#FFF2B7" />
        </linearGradient>
        <radialGradient
          id="paint8_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0608 14.2266) rotate(90.0006) scale(2.17488 3.16202)"
        >
          <stop stopColor="#FF7294" />
          <stop offset="0.416498" stopColor="#FF71A4" />
          <stop offset="1" stopColor="#EF164A" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.4147 10.1232) rotate(-113.466) scale(5.77422 6.62401)"
        >
          <stop stopColor="white" />
          <stop offset="0.588542" stopColor="white" />
          <stop offset="1" stopColor="#DFECFF" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_4706_230266"
          x1="12.1462"
          y1="5.12324"
          x2="14.4809"
          y2="11.0615"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0483618" stopColor="#641471" stopOpacity="0.2" />
          <stop offset="0.59375" stopColor="#FFC09C" />
          <stop offset="1" stopColor="#FFF4CF" />
        </linearGradient>
        <radialGradient
          id="paint11_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.6527 10.1232) rotate(-66.5339) scale(5.77422 6.62401)"
        >
          <stop stopColor="white" />
          <stop offset="0.588542" stopColor="white" />
          <stop offset="1" stopColor="#DFECFF" />
        </radialGradient>
        <linearGradient
          id="paint12_linear_4706_230266"
          x1="7.92024"
          y1="4.16718"
          x2="5.58549"
          y2="10.1055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0483618" stopColor="#641471" stopOpacity="0.2" />
          <stop offset="0.59375" stopColor="#FFC09C" />
          <stop offset="1" stopColor="#FFF4CF" />
        </linearGradient>
        <radialGradient
          id="paint13_radial_4706_230266"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.6677 15) rotate(-164.022) scale(3.81506 6.04879)"
        >
          <stop stopColor="#FFE150" />
          <stop offset="0.526042" stopColor="#FFC321" />
          <stop offset="1" stopColor="#E35011" />
        </radialGradient>
        <clipPath id="clip0_4706_230266">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
